module.exports = __webpack_public_path__ + "img/pdf.b4bda6ac.png";